(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ea-bestsellers"] && !Shopify.designMode) return;
  try {
    
(function(){
  var sec=document.currentScript.closest('[data-ea-bs]')||document.querySelector('[data-ea-bs]');
  if(!sec) return;
  var track=sec.querySelector('[data-ea-track]');
  var prev=sec.querySelector('[data-ea-prev]'), next=sec.querySelector('[data-ea-next]');
  function step(){ var card=track.querySelector('.ea-pc'); return card? card.getBoundingClientRect().width+20 : 300; }
  if(next) next.addEventListener('click',function(){ track.scrollBy({left:step(),behavior:'smooth'}); });
  if(prev) prev.addEventListener('click',function(){ track.scrollBy({left:-step(),behavior:'smooth'}); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ea-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var s=document.currentScript, sec=document.querySelector('[data-ea-hero]');
  if(!sec) return;
  var sun=sec.querySelector('.ea-sun'), sky=sec.querySelector('.ea-hero__sky');
  var raf=null;
  window.addEventListener('scroll',function(){
    if(raf) return;
    raf=requestAnimationFrame(function(){
      var y=window.scrollY||0;
      if(y<900){ if(sun) sun.style.transform='translate(-50%,calc(-50% + '+(y*0.18)+'px)) scale(1)'; if(sky) sky.style.opacity=Math.max(0,1-y/650); }
      raf=null;
    });
  },{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
